module.exports = __webpack_public_path__ + "static/TAKK-0f05cf2e2e2c951a129e7942fd09273e.png";